module.exports = __webpack_public_path__ + "img/spitter-attack-1.994c70a7.png";